export const MICROTRENDS = 'microtrend'
export const MACROTRENDS = 'macrotrend'

export const PAGE_SIZE = 500
